"use client";

/**
 * Scene0ViewTracker — fires `landing_scene_view` for Scene 0 (Mission).
 *
 * Scene0Static is a Server Component (UI-53 LCP fix) so it can't call the
 * `useSceneView` hook directly. This tiny client island delegates to the
 * shared hook using `elementId="scene-0-mission"`, which resolves the
 * Server-rendered section via `document.getElementById` inside the effect.
 *
 * Rendered as a sibling in `app/page.tsx`. No visual output.
 */

import { useSceneView } from "../shared/useSceneView";

export function Scene0ViewTracker() {
  useSceneView({
    sceneId: "0",
    sceneName: "Mission",
    elementId: "scene-0-mission",
  });
  return null;
}
